import { useEffect, useRef } from 'react';
import type { ChartId } from '../catalog/chartCatalog';
import type { ChartDefinition, ChartFetchResult, ChartResult } from '../catalog/types';
import { useCurrentUserInProject } from 'store/user';
import { useAnalyticsStore } from 'store/analytics';
import {
  IDLE_CHART_RESULT,
  normalizeChartFetchResult,
} from './chartResultUtils';
import { resolveChartCanAccess } from './resolveChartCanAccess';

export function useChartWithRefresh(
  id: ChartId,
  definition: ChartDefinition,
  fetch: (enabled: boolean) => ChartFetchResult
): ChartResult {
  const user = useCurrentUserInProject();
  const canAccess = resolveChartCanAccess(definition, user);
  const refreshVersion = useAnalyticsStore(
    (state) => state.chartsUiById[id]?.refreshVersion ?? 0
  );

  const internal = fetch(canAccess);

  const reloadRef = useRef(internal.reload);
  reloadRef.current = internal.reload;

  useEffect(() => {
    if (canAccess && refreshVersion > 0) {
      reloadRef.current();
    }
  }, [refreshVersion, canAccess]);

  if (!canAccess) {
    return IDLE_CHART_RESULT;
  }

  return normalizeChartFetchResult(internal);
}
